import { call, fork, put, select, take } from 'redux-saga/effects';

import * as ProgramApi from 'api/program';
import Sequences from 'defs/sequences';
import EventWrapper from 'models/global/EventWrapper';
import * as profileSagas from 'sagas/profile';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators as dashboardAC } from 'store/dashboard';
import { actionCreators as eventsAC } from 'store/events';
import { actionTypes as loginAT, getHasAuthenticationLoaded, getIsAuthenticated } from 'store/login';
import { actionCreators as programDaysAC } from 'store/programDays';
import { actionCreators as programItemsAC } from 'store/programItems';
import { actionCreators as programAC, getActiveProgram } from 'store/programs';
import { actionCreators as sequencesAC } from 'store/sequences';

export function* loadActiveProgram() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	yield put(programAC.doRequestActiveProgramsLoading(true));
	try {
		const activePrograms = yield call(ProgramApi.fetchActivePrograms);
		yield put(programAC.doRequestActiveProgramsSuccess(activePrograms));
	} catch (e) {
		yield put(programAC.doRequestActiveProgramsFailure());
	} finally {
		yield put(programAC.doRequestActiveProgramsLoading(false));
	}
}

export function* finishProgramManually() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkSaveRequestError());
	}

	yield put(sequencesAC.doStartSequence(Sequences.PROGRAM_IS_QUITTING));

	const isAuthenticated = yield select(getIsAuthenticated);
	const hasAuthenticationLoaded = yield select(getHasAuthenticationLoaded);

	if (!isAuthenticated && !hasAuthenticationLoaded) {
		yield take(loginAT.LOGIN_STATUS_KNOWN);
	}

	const activeProgram = yield select(getActiveProgram);

	yield fork(profileSagas.getUserData, { force: true });

	if (activeProgram && activeProgram.id) {
		try {
			yield put(programAC.doRequestFinishManuallyLoading(true));

			const response = yield call(ProgramApi.finishProgram, activeProgram.id);
			const model = new EventWrapper(response);

			yield put(programAC.doRequestFinishManuallySuccess());
			yield put(eventsAC.doAddEvents(model.getEvents()));
		} catch (err) {
			yield put(programAC.doRequestFinishManuallyFailure());
		}
	} else {
		yield put(programAC.doRequestFinishManuallyFailure());
	}

	yield put(sequencesAC.doFinishSequence(Sequences.PROGRAM_IS_QUITTING));
}

export function* flushAllProgramData() {
	yield put(dashboardAC.doFlushDashboardProgram());
	yield put(programDaysAC.doFlushProgramDays());
	yield put(programAC.doFlushPrograms());
	yield put(programItemsAC.doFlushProgramItems());
}

export function* refetchFinishProgramButton() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkSaveRequestError());
	}

	try {
		const activeProgram = yield select(getActiveProgram);

		if (activeProgram) {
			yield put(programAC.doRequestFinishProgramButton());

			const activePrograms = yield call(ProgramApi.fetchActivePrograms);
			if (activePrograms.length !== 0) {
				yield put(programAC.doRequestFinishProgramButtonSuccess(activePrograms[0]));
			}
		}
	} catch (err) {
		yield put(programAC.doRequestFinishProgramButtonFailure());
	}
}
